import { useMediaQuery } from 'react-responsive';

/**
 * 自适应分段
 * 屏幕 < 768px - 手机领域
 * 屏幕 767px ~ 992px - 平板领域
 * 屏幕 > 992px - 桌面领域
 */

export function useIsMobile() {
  return useMediaQuery({ query: '(max-width: 767px)' });
}

export function useNotPC() {
  return useMediaQuery({ query: '(max-width: 992px)' });
}
